import "./App.css";
import { BrowserRouter, Route, Switch } from "react-router-dom";
import { LandingPage, Home, Detail, Create, Error404 } from "./views";
import axios from "axios";
axios.defaults.baseURL = "https://pi-countries-production-1496.up.railway.app/";


function App() {
  //const location = useLocation() //Hooks
  //console.log(location)
  return (
    <BrowserRouter>
      <div className="App">
        <Switch> 
          <Route exact path="/" component={LandingPage} />
          <Route exact path="/home" component={Home} />
          <Route exact path="/country/:id" component={Detail} />
          <Route exact path="/activity" component={Create} />
          <Route path="/*" component={Error404} />
        </Switch>
      </div>
    </BrowserRouter>
  );
}

export default App;
